<ap-panel type="primary">
    <div ap-panel-body>
        <h1>{{ 'mortgage-interest.title' | apContent }}</h1>
        <filters (filters)="filterChange($event)"></filters>
        <div class="ap-margin-bottom-4 ap-margin-top-3" aria-live="polite">
            @if (interests && interests.length > 0 && loading === loadingState.IDLE) {
                <interests data-testid="interests" aria-busy="false" [interests]="interests"></interests>
            }
            <ap-error [apError]="apError$ | async"> </ap-error>

            @if (interests?.length === 0 && loading === loadingState.IDLE) {
                <h2 aria-busy="false">{{ 'interest-overview.no-result.message' | apContent }}</h2>
            }
            <div class="ap-margin-top-1 ap-text-align-center">
                <ap-spinner
                    [visuallyHiddenLabel]="true"
                    loadingText="{{ 'mortgage-calculation-download.spinner.loading' | apContent }}"
                    readyText="{{ 'mortgage-calculation-download.spinner.ready' | apContent }}"
                    [state]="loading"
                    [icon]="true"
                ></ap-spinner>
            </div>
        </div>
        <appointment></appointment>
    </div>
</ap-panel>
